import React, { useState } from 'react';

import {
    TextField,
    Button,
    IconButton,
    Typography,
    Box,
    Modal,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '586px',
    width: '90%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    // border: '2px solid #0B57D0'
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};

const EditCustom = ({ open, onClose }) => {
    return (
        <Modal open={open} onClose={onClose} fullWidth maxWidth="sm">
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>
                    <Box>
                        <Typography variant="h6" fontSize={'22px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily: 'Manrope' }}>Edit custom field</Typography>
                        <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#64748B', fontFamily: 'Manrope', margin: '4px auto 0' }}>A new section will be included in every member profile, and it will be accessible in the reports.</Typography>
                    </Box>
                    <IconButton onClick={onClose} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}

                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>
                    <Box sx={{ m: '0 auto 24px' }}>
                        <Typography color='#1A1F36' fontWeight={600} mb={0} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope' }}>Field Title</Typography>
                        <TextField placeholder="General" fullWidth size="small" fontWeight={400}
                            sx={{ borderRadius: '6px', margin: '4px auto', fontSize: '14px', fontFamily: 'Manrope' }} />
                    </Box>

                </Box>
                {/* End Body sec  */}

                {/* start Footer sec  */}
                <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>
                    <Button variant="contained" color="primary" className='text-capitalize' sx={{ boxShadow:'unset', backgroundColor: '#F4413D', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #F4413D', fontFamily: 'Manrope' }}>
                        Delete
                    </Button>
                    <Box display="flex" alignItems="center" sx={{ gap: '14px' }}>
                        <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#1A1F36" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily: 'Manrope' }}>
                            Cancel
                        </Button>
                        <Button variant="contained" color="primary" className='text-capitalize' sx={{ boxShadow:'unset', backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0', fontFamily: 'Manrope' }}>
                            Save
                        </Button>
                    </Box>
                </Box>
                {/* End Footer sec  */}
            </Box>
        </Modal>
    );
};
export default EditCustom;
